import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@/ui/Button'
import localize from '@/i18n/translate'

const ButtonField = props => {
  const {
    record,
    locale,
    translate,
    sortable,
    label,
    click,
    width,
    classes,
    clean = true,
    ...attribs
  } = props
  const combinedClasses = classes
    ? (Array.isArray(classes) && [clean && 'button-clean', ...classes]) || [
        clean && 'button-clean',
        classes,
      ]
    : clean && 'button-clean'

  return (
    <Button {...attribs} {...click && { onClick: e => click(record) }} styles={combinedClasses} />
  )
}

ButtonField.propTypes = {
  label: PropTypes.string,
  locale: PropTypes.any,
  record: PropTypes.object,
  sortable: PropTypes.bool,
  clean: PropTypes.bool,
  translate: PropTypes.func.isRequired,
}

export default localize(ButtonField)



// WEBPACK FOOTER //
// ./ui/Data/ButtonField.js